import { Injectable } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { ReviewAirbnbGuestDialogComponent } from './review-airbnb-guest-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class ReviewAirbnbGuestDialogService {
  constructor(private dialog: DialogService) {}

  open(inquiry: Inquiry) {
    return this.dialog
      .openDrawer(ReviewAirbnbGuestDialogComponent, {
        data: { inquiry },
      })
      .afterClosed()
  }
}
